import React, { useState, useEffect } from 'react';
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import toast from 'react-hot-toast';
import FinancialHandler from '../../handlers/FinancialHandler';

export default function ShareLinkModal({ open, onClose }) {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [errors, setErrors] = useState({ email: '', name: '' })

  // reset state when modal opens/closes
  useEffect(() => {
    if (!open) {
      setEmail('')
      setName('')
      setErrors({ email: '', name: '' })
    }
  }, [open])

  const validate = () => {
    const errs = { email: '', name: '' }
    if (!email) {
      errs.email = 'Email is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errs.email = 'Please enter a valid email'
    }
    if (!name.trim()) {
      errs.name = 'Analyst name is required'
    }
    return errs
  }

  const handleCopyLink = async () => {
    try {
        await navigator.clipboard.writeText(window.location.href);
        toast.success("Link copied to clipboard");
    } catch (err) {
        toast.success("Failed to copy link");
    }
  }

  const handleSendEmail = async () => {
    const v = validate()
    if (v.email || v.name) {
      setErrors(v)
      return
    }

    const response = await FinancialHandler.postEmail(email, name, window.location.href);
    toast.success(response);
    setTimeout(() => {
      window.location.href = window.location.href.split("source-select")[0] + "company";   //get company page
    }, 500);
  }

  return (
    <Modal className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-60" open={open} onClose={onClose}>
      <Box className="fixed bg-white rounded-lg py-[80px] px-[60px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <Typography variant="h5" className="text-gray-800 pb-10 text-center">
          Please copy the link of this page or share it via email
        </Typography>
        <TextField
          label="Email address"
          type="email"
          fullWidth
          required
          value={email}
          onChange={e => {
            setEmail(e.target.value)
            if (errors.email) setErrors(prev => ({ ...prev, email: '' }))
          }}
          error={Boolean(errors.email)}
          helperText={errors.email}
          style={{ marginBottom: 16 }}
        />

        <TextField
          label="Analyst name"
          type="text"
          fullWidth
          required
          value={name}
          onChange={e => {
            setName(e.target.value)
            if (errors.name) setErrors(prev => ({ ...prev, name: '' }))
          }}
          error={Boolean(errors.name)}
          helperText={errors.name}
          style={{ marginBottom: 48 }}
        />

        <div className="flex space-x-4">
          <Button
            variant="outlined"
            fullWidth
            onClick={handleCopyLink}
          >
            Copy Link
          </Button>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSendEmail}
          >
            Send Email
          </Button>
        </div>
      </Box>
    </Modal>
  )
}